<div *ngIf="loading$ | async" class="global-loader-overlay">
  <div class="single-color-spinner-wrapper">
    <div class="spinner-ring outer-ring"></div>
    <div class="spinner-ring inner-ring"></div>
    <div class="spinner-core"></div>
  </div>
</div>
